// global/video/video.view-later.dom

function addViewLaterVideosDOM(data, list) {
    $.each(data['videos'], function (index, value) {
        var video = list ? createThumbViewLaterList(value) : createThumbViewLater(value);
        initRemoveViewLaterEvent(video);
        $('#videos-container').append(video).append('\n');
    });
}

function createThumbViewLater(dataVideo) {
    var video = $('<div class="thumb-video">' +
        '<a name="url" href="" class="thumb-duracion">' +
        '<img name="thumb" src=""  width="332px" height="186px">' +
        '<span class="duracion">' +
        '<span class="icon-clock icon"></span> <span name="duration"></span>' +
        '</span>' +
        '</a>' +
        '<h3>' +
        '<a name="title" href=""></a>' +
        '</h3>' +
        '<ul>' +
        '<li>' +
        '<span class="icon-calendar-empty icon icono-calendario"></span>' +
        '<span name="date"></span>' +
        '</li>' +
        '<li><span class="icon-eye-1 icon"></span><span name="views"></span></li>' +
        '<li><span class="icon-comment-empty icon icono-comentarios"></span><span name="comments"></span></li>' +
        '</ul>' +
        '<button name="remove-view-later" class="view-later view-later-added tooltips-botones"><span>Remove from View Later</span><i class="icon-clock"></i></button>' +
        '<a name="challenge-info" class="view-later tooltips-botones challenge-pill" tabindex="0">' +
        '<span></span><i></i>' +
        '</a>' +
        '<a name="live-video" href="#" class="view-later challenge-pill live-pill" title="Live video" tabindex="0"><span>LIVE</span></a>' +
        '</div>');

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    $(video).find("[name='url']").attr('href', dataVideo.url);
    $(video).find("[name='duration']").text(dataVideo.duration);
    $(video).find("[name='title']").html(dataVideo.title).attr('href', dataVideo.url);
    $(video).find("[name='date']").text(dataVideo.date);
    $(video).find("[name='views']").text(kFormat(parseInt(dataVideo.views ? dataVideo.views.replace(/[\.,\s]/g, '') : 0), 1));
    $(video).find("[name='comments']").text(dataVideo.comments);
    $(video).find("[name='remove-view-later']").data('api-url', dataVideo.viewLaterAPIUrl);

    if (typeof global_tokyvideo_text_on != 'undefined') {

        var channel = $('<p> ' + global_tokyvideo_text_on + ' <a href="' + dataVideo.channelURL + '">' + dataVideo.channelName + '</a> <span class="icon-ok-circled icon"></span></p>');

        if (!dataVideo.channelVerified) {
            $(channel).find('span.icon-ok-circled').remove();
        }

        $(video).find('h3').after($(channel));
    }

    if (dataVideo.viewed) {
        $(video).addClass('thumb-watched');
    }

    if (dataVideo.challenge != null) {
        $(video).find("[name='challenge-info']").addClass(dataVideo.challenge.type).attr('title', dataVideo.challenge.title).attr('href', dataVideo.challenge.url);
        $(video).find("[name='challenge-info']").find('span').html(dataVideo.challenge.score);
        $(video).find("[name='challenge-info']").find('i').addClass(dataVideo.challenge.icon).html(dataVideo.challenge.position);
    }

    if (!dataVideo.liveStream) {
        $(video).find("[name='live-video']").remove();
    }

    return video;
}

function createThumbViewLaterList(dataVideo) {
    var video = $('<div class="video-relacionados thumb-video thumb-view-later">' +
        '<a name="url" href="" class="thumb-duracion">' +
        '<img name="thumb" src=""  width="332px" height="186px">' +
        '</a>' +
        '<h3>' +
        '<a name="title" href=""></a>' +
        '</h3>' +
        '<p>' +
        '<span name="text_on"></span> ' +
        '<a name="channel_title" href=""></a> ' +
        '<span class="icon-ok-circled icon"></span>' +
        '</p>' +
        '<ul>' +
        '<li><span class="icon-eye-1 icon"></span><span name="views"></span></li>' +
        '<li><span class="icon-comment-empty icon icono-comentarios"></span><span name="comments"></span></li>' +
        '</ul>' +
        '<a name="remove-view-later" title="Remove from View Later" class="btn-generico btn-naranja btn-borrar-fav" href="#"><span class="icon-clock"></span></a>' +
        '</div>');

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    $(video).find("[name='url']").attr('href', dataVideo.url);
    $(video).find("[name='duration']").text(dataVideo.duration);
    $(video).find("[name='title']").html(dataVideo.title).attr('href', dataVideo.url);
    $(video).find("[name='views']").text(kFormat(parseInt(dataVideo.views ? dataVideo.views.replace(/[\.,]/g, '') : 0), 1));
    $(video).find("[name='comments']").text(dataVideo.comments);

    if (typeof global_tokyvideo_text_on != 'undefined') {

        $(video).find("[name='text_on']").text(global_tokyvideo_text_on);
    }

    if (!dataVideo.channelVerified) {
        $(video).find('span.icon-ok-circled').remove();
    }

    $(video).find("[name='channel_title']").text(dataVideo.channelName).attr('href', dataVideo.channelURL);
    $(video).find("[name='remove-view-later']").data('api-url', dataVideo.viewLaterAPIUrl);

    if (dataVideo.viewed) {
        $(video).addClass('thumb-watched');
    }

    return video;
}